import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, } from 'rxjs/operators';
import { ErrorService } from 'src/app/error.service';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { Subject } from 'rxjs/Subject';
  
import { GlobalComponent } from 'src/app/global/global.component';
import { serviceactivityBO } from '../manage-service.modal';

@Injectable({
  providedIn: 'root'
})
export class ServiceTaxDataservice extends Subject<DataStateChangeEventArgs>{
  constructor(private http: HttpClient, public errorService: ErrorService, public global: GlobalComponent) {
    super();
  }
  public execute(state: serviceactivityBO): void {
    this.getServiceTaxGroup(state).subscribe(x => super.next(x));
  }
  getServiceTaxGroup(state?: serviceactivityBO): Observable<DataStateChangeEventArgs> {
    return this.http.post<any>("api/ServiceTax/GetServiceTaxList?", state)
      .pipe(map(
        (response: any) =>
          <any>{
            result: response['result'],
            count: response['count']
          }
      ))
  }
}
